import { render, staticRenderFns } from "./sImgNum.vue?vue&type=template&id=6d2a2abf&scoped=true"
import script from "./sImgNum.vue?vue&type=script&lang=js"
export * from "./sImgNum.vue?vue&type=script&lang=js"
import style0 from "./sImgNum.vue?vue&type=style&index=0&id=6d2a2abf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a2abf",
  null
  
)

export default component.exports